import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import buildConfig from './util/buildConfig';

const initAppLayer = () => {
  const appLayerWrapper = document.querySelector('[data-app-layer="main"]');
  if (!appLayerWrapper) return;

  // Render app
  ReactDOM.render(
    <>
      <App />
    </>,
    appLayerWrapper
  );
}

initAppLayer();
